import styled from "styled-components"
import { Main, Papa, EndDiv, EndText2, EndeText, TextTitle, UpDiv, IconImg, Icons, Icons2} from "../shared/StylePage"
import icn1 from '../img/Footer/oneG.png'
import icn2 from '../img/Footer/TwoG.png'
import icn3 from '../img/Footer/ThreeG.png'
import iconsquare from '../img/Footer/square.png'
import iconrhomb from '../img/Footer/rhomb.png'
import iconsun from '../img/Footer/sugnsign.png'

const Link = styled.a`
    text-decoration: none;
    font-size: 27px;
    color: #000000;
    width: ${props => props.width}px;
    @media(width <= 828px){
        font-size: 24px;
        text-align: center;
    }
    &:hover{
        color: #FFFFFF;
    }
`
const DivLink = styled.div`
    display: flex;
    margin-right: 33px;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-end;
    @media(width <= 828px){
        flex-direction: column;
        align-items: center;
    }
`
//const Img = styled.div`
//    display: flex;
//    margin-left: 33px;
//    width: fit-content;
//    gap: 8px;
//    align-items: center;
//    @media(width <= 828px){
//        margin: 10px auto 0px auto;
//    }
//`
const Verrx = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`
export const Header = () =>{
    const component= [{title:'о форуме', link:'#s1'}, {title:'даты', link:'#s2'}, {title:'программа', link:'#s3'}, {title:'эксперты', link:'#s4'}, {title:'контакты', link:'#s5'}]
    return(
    <Papa color="#E3022D">        
        <Main  padtop='29' padbott='60' wrap='wrap'>
            <EndDiv >
                <EndeText>Форум местных сообществ</EndeText>
                <EndText2>7-30 апреля</EndText2>
            </EndDiv>
            <Verrx>
                <TextTitle>«Удмуртия - вместе!»</TextTitle>
            </Verrx>
            <DivLink>
            {component.map((e) => {
                return <Link href={e.link} width={e.width}>{e.title}</Link>
            })}
            </DivLink>
            <UpDiv padtop='30'>
                <Icons2>
                    <IconImg src={iconsquare} width='19' height='19'/>
                    <IconImg src={iconsun} width='57' height='57'/>
                    <IconImg src={iconrhomb} width='45' height='45'/>
                </Icons2>
                <Icons>
                    <IconImg src={icn1} width='120' height='110'/>
                    <IconImg src={icn2} width='99' height='110'/>
                    <IconImg src={icn3} width='130' height='110'/>
                </Icons>
            </UpDiv>
        </Main>
        
    </Papa>
    )
}